import { render, staticRenderFns } from "./PackagesTab.vue?vue&type=template&id=7253ce9e&scoped=true&"
import script from "./PackagesTab.vue?vue&type=script&lang=js&"
export * from "./PackagesTab.vue?vue&type=script&lang=js&"
import style0 from "./PackagesTab.vue?vue&type=style&index=0&id=7253ce9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253ce9e",
  null
  
)

export default component.exports